(() => {
  const source = document.currentScript;
  const rawDate = source?.dataset.yamSummaryDate;
  const productId = source?.dataset.productId;
  if (!rawDate || !productId || !/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) return;
  const date = new Date(rawDate + 'T12:00:00Z');
  if (Number.isNaN(date.getTime())) return;
  const formattedDate = new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
  }).format(date);
  const labelText = 'Résumé le ' + formattedDate + ' et sélectionné par IA à partir des avis clients récents';
  const selector = '#judgeme_product_reviews[data-id="' + productId + '"]';
  let scheduled = false;
  const update = () => {
    const label = document.querySelector(selector + ' .jm-ai-insights .jm-ai-disclaimer .jm-text');
    if (!label || label.textContent === labelText) return;
    label.textContent = labelText;
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };
  const root = document.getElementById('MainContent');
  if (!root) return;
  const observer = new MutationObserver(schedule);
  observer.observe(root, { childList: true, characterData: true, subtree: true });
  update();
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    observer.observe(root, { childList: true, characterData: true, subtree: true });
    update();
  });
})();
